import * as i0 from '@angular/core';
import * as i1 from './toggle.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/icon.component';
import * as i4 from './toggle.component';
import * as i5 from '../icon/icon.module';
export const ElToggleModuleNgFactory:i0.NgModuleFactory<i1.ElToggleModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ElIconComponent = (<any>(null as any));
var _decl0_12:i4.ElToggleComponent = (<any>(null as any));
var _decl0_13:i2.AsyncPipe = (<any>(null as any));
var _decl0_14:i2.UpperCasePipe = (<any>(null as any));
var _decl0_15:i2.LowerCasePipe = (<any>(null as any));
var _decl0_16:i2.JsonPipe = (<any>(null as any));
var _decl0_17:i2.SlicePipe = (<any>(null as any));
var _decl0_18:i2.DecimalPipe = (<any>(null as any));
var _decl0_19:i2.PercentPipe = (<any>(null as any));
var _decl0_20:i2.TitleCasePipe = (<any>(null as any));
var _decl0_21:i2.CurrencyPipe = (<any>(null as any));
var _decl0_22:i2.DatePipe = (<any>(null as any));
var _decl0_23:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_24:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_25:i2.KeyValuePipe = (<any>(null as any));
var _decl0_26:i2.CommonModule = (<any>(null as any));
var _decl0_27:i5.ElIconModule = (<any>(null as any));
var _decl0_28:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_29:i0.ElementRef<any> = (<any>(null as any));
function _View_ElToggleComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.primary;
  currVal_0;
  const currVal_1:any = _decl0_12.success;
  currVal_1;
  const currVal_2:any = _decl0_12.warning;
  currVal_2;
  const currVal_3:any = _decl0_12.danger;
  currVal_3;
  const currVal_4:any = _decl0_12.info;
  currVal_4;
  const currVal_5:any = _decl0_12.labelLeft;
  currVal_5;
  const currVal_6:any = _decl0_12.labelRight;
  currVal_6;
  const currVal_7:any = _decl0_12.labelStart;
  currVal_7;
  const currVal_8:any = _decl0_12.labelEnd;
  currVal_8;
}
function _View_ElToggleComponent_1_1():void {
  if (_decl0_12.checked) {
    var _any:any = (null as any);
    const currVal_0:any = 'checkmark-bold-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_11.html;
    currVal_2;
    const currVal_3:any = _decl0_11.primary;
    currVal_3;
    const currVal_4:any = _decl0_11.info;
    currVal_4;
    const currVal_5:any = _decl0_11.success;
    currVal_5;
    const currVal_6:any = _decl0_11.warning;
    currVal_6;
    const currVal_7:any = _decl0_11.danger;
    currVal_7;
  }
}
function _View_ElToggleComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.checked;
  currVal_0;
  const currVal_1:any = _decl0_12.disabled;
  currVal_1;
  const currVal_2:any = _decl0_12.checked;
  currVal_2;
  const currVal_3:any = _decl0_12.checked;
  currVal_3;
  const currVal_4:any = _decl0_12.checkState();
  currVal_4;
  const currVal_5:any = _decl0_12.checked;
  currVal_5;
  const pd_6:any = ((<any>_decl0_12.updateValue(_any)) !== false);
  const pd_7:any = ((<any>_decl0_12.onTouched()) !== false);
  const pd_8:any = ((<any>_decl0_12.onInputClick(_any)) !== false);
}
